// Copyright ©️ 2026 eVolve MEP, LLC

import { Button, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import { WrappedModal } from 'components/Mantine/Modals/WrappedModal';
import classes from 'modules/Shop/EvolveFabrication/BendCreator/Shell/BendCreatorShell.module.css';

type Props = {
  onExit: () => void;
  /** Bends in the bend list that have not been added to a work order. When above 0, exiting asks for confirmation first. */
  bendsToDiscard: number;
};

export const ShellExitButton = ({ onExit, bendsToDiscard }: Props) => {
  const [confirming, { open: openConfirmation, close: closeConfirmation }] = useDisclosure(false);
  const plural = bendsToDiscard === 1 ? '' : 's';

  return (
    <>
      <Button
        className={classes.topBarTextButton}
        variant="default"
        onClick={() => (bendsToDiscard > 0 ? openConfirmation() : onExit())}
      >
        Exit
      </Button>
      <WrappedModal
        title="Discard bend list"
        opened={confirming}
        onClose={closeConfirmation}
        onConfirm={onExit}
        confirmationText="Discard and exit"
        buttonColor="red"
      >
        <Text>
          The bend list has {bendsToDiscard} bend{plural} that {bendsToDiscard === 1 ? 'has' : 'have'} not been added to
          a work order. Exiting the bend creator will discard {bendsToDiscard === 1 ? 'it' : 'them'}.
        </Text>
      </WrappedModal>
    </>
  );
};
